import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';
import { EntityType } from '../../../entity.types';
import { HideWrapper } from '../../HideWrapper';
import { EntityInfos } from '../../../expertises/infos/EntityInfos';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../../../components/EntityBlockComponents';

type Props = {
  decisionCount: number;
  entityType: EntityType;
  entityId: string;
  entityName: string;
};

export const CompanySizeTypologiesPresentation: FC<Props> = ({
  decisionCount,
  entityType,
  entityId,
  entityName,
  children,
}) => {
  return (
    <HideWrapper source="company_size_typologies_chart">
      <EntityBlock>
        <EntityBlockTitle>
          <FormattedMessage id="entity/charts/typologies/sizes/CompanySizeTypologiesPresentation.tsx/1" />
        </EntityBlockTitle>
        <EntityInfos
          decisionCount={decisionCount}
          entityType={entityType}
          lawyerId={entityId}
          entityName={entityName}
        />
        <div className="entity__chart">{children}</div>
      </EntityBlock>
    </HideWrapper>
  );
};
